<template>
    <div>
        <v-list class="scroll-updater-main-container">
            <v-list-item v-scroll="scrollTopOverDetect" v-for="item in items" :key="item.title" :to="{ name: 'UiList', params: { poiId: item.id } }">
                <Poi :poiId="item.id" :poiName="item.title" />
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
import axios from "axios";
import { EventBus } from "@/event-bus";
import { functions } from "../functions";
import { sort } from "fast-sort";
import Poi from '@/components/Poi';
import { scrollUpdater } from "../mixins/scrollUpdater";
import { appCaller } from "../mixins/appCaller";

export default {
    name: "PoiList",

    components: {
        Poi
    },

    props: {
        msg: String
    },

    mixins: [scrollUpdater, appCaller],

    data() {
        return {
            items: [],
            rootApi: process.env.VUE_APP_ROOT_API,
            subdepId: this.$route.params.subdepId,
            updIntHandler: null,
            timeoutHandlerLoadList: null
        };
    },

    /*
     * - Atualização forçada pelo usuário: Aplicar o efeito deslizar para
     * baixo (scrollTopOverDetect), para atualizar a tela.
     *
     * - Atualização automática: Um timer (appCaller) é usado para indicar
     * ciclos onde de atualização dos dados na tela.
     *
     * - Reset do timer: Caso haja um atualização forçada pelo usuário, o
     * timer é resetado (appCallerDispatchEventByLevel).
     *
     * - Evento de atualização: A atualização será disparada por um evento
     * específico (baseado em níveis) que todos os participantes da tela deverão ouvir.
     *
     * - Níveis do Evento de atualização: Inicialmente existirão 2 níveis,
     * quando o evento é disparado, os "listeners" terão uma condição que verificará
     * se o nível do evento é maior ou igual a seu próprio nível
     *
     * - Implementação
     *
     * 1) Ouvir o evento "scrollTopOverDetect" e chamar o método "appCallerDispatchEventByLevel"
     *
     * 2) Instanciar o Listener informando o nível e função a ser executada.
     *
     * 3) Os passos 1 e 2 devem ser executados no evento "mounted" e não no "created"
     *
     * Ex:
     *   //1
     *   EventBus.$on("scrollTopOverDetect", () => {
     *       this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
     *   });
     *
     *   //2
     *   this.appCallerListenEventByLevel(this.$updNowLevels.level1, () => {
     *       this.loadList();
     *   });
     */

    created: function () {
        EventBus.$emit("eventPageLoad", { name: "Pontos de interesse" });
    },

    mounted: function () {
        //Ação do usuário que dispara evento de atualização.
        EventBus.$on("scrollTopOverDetect", function () {
            this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
        }.bind(this));

        //Atualiza informações da tela quando evento for disparado.
        this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {

            //Previne muitos eventos seguidos num curto espaço de tempo.
            if (this.timeoutHandlerLoadList) {
                clearTimeout(this.timeoutHandlerLoadList);
            }
            this.timeoutHandlerLoadList = setTimeout(() => {
                this.loadList();
            }, 2000);

        }.bind(this));
    },

    beforeDestroy() {
    },

    afterCreate() { },

    beforeCreate() { },

    methods: {

        loadList() {
            console.log("PoiList::loadList");
            EventBus.$emit("eventWaitingStart", { opacity: 0 });
            const url = this.rootApi + "/poi/list/" + this.subdepId;
            axios
                .get(url, axios.getHeaders())
                .then((response) => {
                    this.createList(response.data);
                })
                .catch((err) => {
                    return functions.parseCatch(err, this.$appMessages.err404);
                })
                .finally(() => {
                    EventBus.$emit("eventWaitingEnd");
                });

        },

        createList(pois) {

            this.items = [];

            pois.map((elem) => {
                this.items.push({
                    id: elem.id,
                    title: elem.title,
                    icon: false,
                    avatar: elem.icon
                });
            });

            this.items = sort(this.items).asc([(i) => i.title]);
        },

        openPageUi(uiId) {

        }
    }
};
</script>

<style scoped></style>
